module.exports = __webpack_public_path__ + "img/drive_white.8111ac65.svg";